module.exports = __webpack_public_path__ + "static/media/ContactRight_VN.d3cd9ef9.png";